/** Auth user token key */
export const AUTH_USER_TOKEN_KEY = 'ReactAmplify.TokenKey';
export const AUTH_USER_DEVICE_KEY = 'ReactAmplify.DeviceKey';
